module.exports = __webpack_public_path__ + "img/location.1d631b12.svg";